import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { CiSearch } from "react-icons/ci";
import { FaArrowRightLong } from "react-icons/fa6";
import { IoSearchOutline } from "react-icons/io5";
import { MdClose } from "react-icons/md";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { sampleProducts } from "../lib/FakeData";
import ProductCard from "./ProductCard";
import { useSelector } from "react-redux";

// const ProductCard = ({ product }) => {
//     return (
//         <div className="p-2 flex flex-col space-y-1 cursor-pointer">
//             <div className="border rounded-md w-full flex items-center mb-2 overflow-hidden">
//                 <img src={product?.image?.url} alt={product.name} className="w-full h-auto object-contain " />
//             </div>
//             {product.day && (
//                 <div className="text-xs text-gray-400">{product.day}</div>
//             )}
//             <div className="text-xs font-semibold">{product.name}</div>
//             <div className="flex gap-2 flex-wrap items-center">

//                 {product.discountPrice ? (
//                     <div className="text-xs text-gray-500 line-through">{product.price}</div>
//                 ) : (
//                     <div className="text-xs text-green-600">{product.price}</div>
//                 )}
//                 {product.discountPrice && (
//                     <div className="text-xs text-red-600">{product.discountPrice}</div>
//                 )}
//                 {product.discountPercent && (
//                     <div className="text-xs bg-green-100 text-green-700 px-1 rounded">{product.discountPercent}%</div>
//                 )}
//             </div>
//         </div>
//     );
// };

export const Search = ({ className }) => {
    const { register, handleSubmit, reset, watch } = useForm({
        defaultValues: { query: "" },
    });
    const queryValue = watch("query");

    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const productList = useSelector((state) => state.productList);
    const {  error, products } = productList;
    // Giả lập fetch API
    useEffect(() => {
        if (!queryValue) {
            setResults([]);
            setShowDropdown(false);
            return;
        }

        setLoading(true);
        setShowDropdown(true);

        const timer = setTimeout(() => {
            // Giả lập dữ liệu sản phẩm
            const fakeProducts = products;

            const filtered = fakeProducts.filter((item) =>
                item.name.toLowerCase().includes(queryValue.toLowerCase())
            );

            setResults(filtered);
            setLoading(false);
        }, 500);

        return () => clearTimeout(timer);
    }, [queryValue,products]);

    const submitHandler = (data) => {
        console.log("Search submit:", data);
        setShowDropdown(false);
    };

    const clearInput = () => {
        reset({ query: "" });
        setResults([]);
        setShowDropdown(false);
    };

    return (
        <div className={`relative w-full flex justify-center items-center ${className}`}>
            <form
                onSubmit={handleSubmit(submitHandler)}
                name="search"
                className={`flex relative rounded-full border-[2px] border-[--color-button-2] w-full h-full overflow-hidden `}
            >
                <input
                    {...register("query")}
                    placeholder="tìm kiếm sản phẩm..."
                    type="text"
                    className="flex-1 h-full outline-none px-4 bg-transparent  w-[70%]"
                    onFocus={() => queryValue && setShowDropdown(true)}
                />

                {queryValue && (
                    <button
                        type="button"
                        onClick={clearInput}
                        className="text-red-600 mx-1 w-[10%]"
                    >
                        <MdClose />
                    </button>
                )}

                <button
                    type="submit"
                    className="bg-[--color-button-2] w-[20%] h-full rounded-r-full text-sm flex justify-center items-center"
                >
                    <span className="hidden xl:block">Tìm kiếm</span>
                    <span className="block xl:hideen"><IoSearchOutline  /></span>
                </button>
            </form>

            {showDropdown && (
                <div className="absolute top-full left-0 w-full bg-white  shadow-md rounded-b-md z-50 p-4 transition-all duration-300">


                    {loading ? (
                        <div className="w-full flex justify-center items-center"> <div className="text-center text-gray-500 loader"></div> </div>
                    ) : results.length > 0 ? (
                        <>
                            <div className=" mb-2">Sản phẩm</div>
                            <div className="border-t border-t-[--color-button-1] w-full  my-2"></div>
                            <div className="grid grid-cols-2 xl:grid-cols-3 gap-4">
                                {results?.map((product, index) => (
                                    <ProductCard key={index} product={product} className={"!p-0"}/>
                                ))}
                            </div>
                        </>
                    ) : (
                        <div className="text-center text-gray-500 py-8">Không tìm thấy sản phẩm nào</div>
                    )}
                   
 
                    <Link to={"/category"} className=" bg-[--color-button-1] flex  w-full p-2 my-2 items-center gap-2 text-sm group">
                    Tìm kiếm "{queryValue}" 
                        <FaArrowRightLong className="transition-transform duration-200 group-hover:-translate-x-1"/>
                         </Link>
                </div>
            )}
        </div>
    );
};
